import { EditorialReadingListWidget } from 'open-modules/cbcrc/feature/topic/editorial-reading-list';
import { component, demoFile } from 'system/demo';

demoFile('open-modules/cbcrc/feature/topic/editorial-reading-list');

const relatedArticles = [
    {
        id: 1,
        picture: 'https://placehold.co/250x150',
        published: true,
        text: 'A text article',
        type: 'text',
        url: 'https://www.google.com',
    },
    {
        id: 2,
        picture: 'https://placehold.co/250x150',
        published: true,
        text: 'An audio article',
        type: 'audio',
        url: 'https://www.google.com',
    },
    {
        id: 3,
        picture: 'https://placehold.co/250x150',
        published: true,
        text: 'A media article',
        type: 'media',
        url: 'https://www.google.com',
    },
    {
        id: 4,
        picture: 'https://placehold.co/250x150',
        published: true,
        text: 'A text article',
        type: 'text',
        url: 'https://www.google.com',
    },
];

component('EditorialReadingListWidget', EditorialReadingListWidget, {
    state: { collections: { relatedArticles } },
});
